import React, { useState, useContext, useEffect } from 'react';
import Menu from './Menu.jsx';
import Home from './home/Home.jsx';
import Dispatch from './dispatch/Dispatch.jsx';
import PrivacyPolicy from './privacy-policy/PrivacyPolicy.jsx';
import Login from './login/Login.jsx';
import Style from './Style.jsx';
import Vendor from './vendor/Vendor.jsx';
// import Driver from './driver/Driver.jsx';
import StoreMenu from './store/Menu.jsx';
import Account from './account/Account.jsx';
import Cart from './cart/Cart.jsx';
import Orders from './orders/Orders.jsx';
import Order from './orders/Order.jsx';
import Footer from './Footer.jsx';
import Person, { PersonContext } from './providers/Person.jsx';

const Providers = () => (
    <Person>
        <App />
    </Person>
);
export default Providers;

const App = () => {

    const GA_MEASUREMENT_ID = 'G-7LZWJH4MRN';

    useEffect(() => {
        // Load gtag.js
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        script.async = true;
        document.head.appendChild(script);

        // Initialize GA
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        window.gtag = gtag;

        gtag('js', new Date());
        gtag('config', GA_MEASUREMENT_ID);
    }, []);

    const { person } = useContext(PersonContext);
    const [route, setRoute] = useState({ screen: window.location.href.split("/").pop().split("#")[0].split("?")[0] });

    let pages = [
        "login",
        "privacy-policy",
        "dispatch",
        "vendor",
        // "driver",
        "store",
        "cart",
        "account",
        "orders",
        "order",
    ]
    return <>

        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between" }}>

            <div style={{ width: "100%" }}>
                <Style />
                <Menu />
                {!pages.includes(route.screen) && <Home />}
                {route.screen === "login" && <Login />}
                {route.screen === "privacy-policy" && <PrivacyPolicy />}
                {route.screen === "dispatch" && (person?.roles || [].includes("dispatch") ? <Dispatch /> : <Home waitForAuth />)}
                {route.screen === "vendor" && (person?.roles || [].includes("vendor") ? <Vendor /> : <Home waitForAuth />)}
                {/* {route.screen === "driver" && (person?.roles || [].includes("driver") ? <Driver /> : <Home waitForAuth />)} */}
                {route.screen === "store" && <StoreMenu />}
                {route.screen === "cart" && <Cart />}
                {route.screen === "account" && <Account />}
                {route.screen === "orders" && <Orders />}
                {route.screen === "order" && <Order />}
            </div>
            <div style={{ width: "100%" }}><Footer /></div>

        </div>

    </>;
}